import {gql} from '@apollo/client';
import {CatalogPlaylistComplete} from '../../../../../../graphql/CatalogPlaylistCompleteFragment';

export const RECOMMENDED_PLAYLISTS_QUERY = gql`
    query recommendedPlaylists {
        me {
            id
            library {
                recommendations {
                    ...CatalogPlaylistComplete
                }
            }
        }
    }
    ${CatalogPlaylistComplete.catalogPlaylist}
`;
